import { RootState } from "../rootReducer";
import { createSelector } from "@reduxjs/toolkit";

export const notificationStatus = createSelector(
    [(state: RootState) => state.notifications.isLoading],
    isLoading => isLoading
)

export const notificationSuccessState = createSelector(
    [(state: RootState) => state.notifications.notificationSuccess],
    notificationSuccess => notificationSuccess
)

export const notificationFailureState = createSelector(
    [(state: RootState) => state.notifications.notificationFailure],
    notificationFailure => notificationFailure
)

export const notifications = createSelector(
    [(state: RootState) => state.notifications.notifications],
    notifications => notifications
)

export const totalUnreadNotifications = createSelector(
    [(state: RootState) => state.notifications.totalUnreadNotifications],
    totalUnreadNotifications => totalUnreadNotifications
)

export const notificationPagination = createSelector(
    [(state: RootState) => state.notifications],
    (notificationState) => ({
        currentPage: notificationState.currentPage,
        nextPage: notificationState.nextPage,
        totalPages: notificationState.totalPages,
    })
)

